import React from 'react';

const WhoWeAre = () => {
  return (
    <div className="container py-5">
      {/* Title Section */}
      <div className="row">
        <div className="col-12 text-center mb-4">
          <h2 className="display-4">Who We Are</h2>
          <hr className="w-25 mx-auto" />
        </div>
      </div>

      {/* Content Row */}
      <div className="row align-items-center">
        {/* First Column: Styled Content */}
        <div className="col-md-6">
  <p className="lead">
    Welcome to <strong>Aditya Birla Finance</strong> — your dependable partner in achieving your financial aspirations. We’re not just a financial services provider; we’re committed to empowering your dreams and ambitions.
  </p>
  <p>
    At Aditya Birla Finance, we provide more than loans — we offer <em>tailored financial solutions</em>. Whether it’s purchasing your dream home, expanding your business, or planning for higher education, our wide range of innovative products is designed to meet your unique needs.
  </p>
  <p>
    Partner with us to build a future full of opportunities and financial stability. With a legacy of trust and a customer-focused approach, our dedicated team is here to guide you every step of the way toward success.
  </p>
</div>


        {/* Second Column: Image with Border Radius */}
        <div className="col-md-6">
          <img
            src="./img2.jpg"
            alt="About Axis Fincorp"
            className="img-fluid rounded"
          />
        </div>
      </div>
    </div>
  );
};

export default WhoWeAre;
